import { useState } from 'react'
import { useRecordContext, TextInput } from 'react-admin'
import { InputAdornment } from '@material-ui/core'

// @todo: Change the input number for a timepicker.
export default function TimePicker({ source, ...rest }) {
  const record = useRecordContext()
  const [value, setValue] = useState(record ? record[source] : null)

  return (
    <TextInput
      {...rest}
      source={source}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      type="number"
      InputProps={{
        endAdornment: <InputAdornment position="end">heures</InputAdornment>,
      }}
    />
  )
}
